import React from 'react';

export default function Project(props) {

  const { title, subheading, imgURL, activeLink, setActiveLink } = props;
  
  const onClickHandler = (e) => {
    if(activeLink == title) {
      e.preventDefault();
      setActiveLink("");
    } else {
      setActiveLink(title);
    }
  }

  return (
    <div className="project">
      <div className="title">
        <div className="titleInner">
          <h3>{title}</h3>
        </div>
        <h4>{subheading}</h4>
      </div>
      <div id={title} className="projectImage">
        <a href={`#${title}`} onClick={onClickHandler} className={ activeLink == title ? "active" : ""}>
          <img src={imgURL}/>
          { activeLink != title ? <p>See More</p> : <p>Collapse</p> }
        </a>
      </div>
      { activeLink == title &&
        <div className="body">
          {props.children}
        </div>
      }
    </div>
  )

}